export const APPROVAL_STATUS = [
  {
    value: '',
    label: '全部',
  },
  {
    value: 0,
    label: '审批中',
  },
  {
    value: 1,
    label: '已入驻',
  },
  {
    value: 2,
    label: '驳回',
  },
  {
    value: 3,
    label: '已停止合作',
  },
]

export const APPROVAL_STATUS_MAP = {
  0: {
    label: '审批中',
    type: 'progress',
  },
  1: {
    label: '已入驻',
    type: 'success',
  },
  2: {
    label: '驳回',
    type: 'danger',
  },
  3: {
    label: '已停止合作',
    type: 'danger',
  },
}

export const ACCOUNT_TYPE = [
  {
    label: '个人',
    value: 1,
  },
  {
    label: '企业',
    value: 2,
  },
]
// 订单状态 1:已支付，2:失败，3:未支付，4:处理中，5:已取消
export const STATUS = {
  1: '已支付',
  2: '失败',
  3: '未支付',
  4: '处理中',
  5: '已取消',
  6: '部分退款',
  7: '全部退款',
  8: '退款中',
}
export const STATUS_ENUM = {
  PAID: '1',
  FAILED: '2',
  NO_PAY: '3',
  DEALING: '4',
  CANCELED: '5',
  REFUND_PART: '6',
  REFUND_ALL: '7',
  REFUNDING: '8',
}
export const ORDER_TYPE_MAP = {
  PAID: '已支付',
  FAILED: '失败',
  NO_PAY: '未支付',
  LOCKED: '处理中',
  DEALING: '处理中',
  CANCELED: '已取消',
  REFUND_PART: '部分退款',
  REFUND_ALL: '全部退款',
  REFUNDING: '退款中',
}
export const ORDER_STATUS_ENUM = {
  PAID: 'PAID',
  FAILED: 'FAILED',
  NO_PAY: 'NO_PAY',
  DEALING: 'DEALING',
  LOCKED: 'LOCKED',
  CANCELED: 'CANCELED',
  REFUND_PART: 'REFUND_PART',
  REFUND_ALL: 'REFUND_ALL',
  EXPIRED: 'EXPIRED',
  REFUNDING: 'REFUNDING',
}
// 0:已申请代付 1:已代付 2:驳回代付请求 3:取消代付 4.未申请代付
export const AGENT_PAY_TYPE = {
  0: '已申请',
  1: '已代付',
  2: '已驳回',
  3: '已取消',
  4: '未申请',
}

export const AGENT_PAY_TYPE_MAP = {
  APPLY_AGENT: 0,
  USED_AGENT: 1,
  REFUSE_AGENT: 2,
  CANCEL_AGENT: 3,
  NO_APPLY_AGENT: 4,
}

// 支付类型 0自付 1代付
export const ORDER_PAY_TYPE = {
  0: '自付',
  1: '代付',
}

export const ORDER_TYPE = {
  NEW: '新购',
  RENEW: '续费',
  RESIZE_FORMULA: '配置变更',
  TEMP_UPGRADE: '临时升配',
}

export const PAY_TYPE = {
  1: '预付费',
  2: '后付费',
}

// 付费类型 1：预付费,2：后付费
export const PAY_TYPE_MAP = {
  PRE_PAID: '预付费',
  POST_PAID: '后付费',
}
export const CHARGE_MODE = {
  CONFIG: '按配置',
  FLOW: '按用量',
  MONTHLY: '包年包月',
  ONCE: '一次性计费',
}
export const CHARGE_TYPE = [
  {
    key: '全部',
    value: '',
  },
  {
    key: '按配置',
    value: 1,
  },
  {
    key: '按用量',
    value: 2,
  },
  {
    key: '包年包月',
    value: 3,
  },
  {
    key: '按次',
    value: 4,
  },
  {
    key: '抢占式',
    value: 5,
  },
]
export const ARREAR_BILL_TYPE = [
  {
    key: '已付费账单',
    value: 2,
  },
  {
    key: '欠费账单',
    value: 1,
  },
]

export const TIME_UNIT = {
  HOUR: '小时',
  DAY: '天',
  MONTH: '个月',
  YEAR: '年',
}
